/**
 * Predictive Search — uses Shopify's /search/suggest.json API
 * Renders results grouped by type (products, pages, articles)
 */
(function () {
  function initPredictiveSearch() {
    const modal = document.getElementById('PredictiveSearch');
    if (!modal) {
      console.warn('Predictive Search: Modal not found');
      return;
    }

    // Guard against ancestor stacking contexts (transform/filter/sticky) trapping
    // this fixed overlay under the header. No-op when already a direct <body> child.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const input = modal.querySelector('[data-search-input]');
    const resultsContainer = modal.querySelector('[data-search-results]');
    const closeBtn = modal.querySelector('[data-search-close]');
    const backdrop = modal.querySelector('[data-search-backdrop]');
    let debounceTimer;

    // Open Modal
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Fade in effect handled by CSS
      setTimeout(() => {
        if (input) input.focus();
      }, 100);
    }

    // Close Modal
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (input) input.value = '';
      if (resultsContainer) resultsContainer.innerHTML = '';
    }

    // Event Delegation for Triggers (Handles dynamic headers)
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-search-trigger]');
      if (trigger) {
        e.preventDefault();
        open();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    // Prevent empty search submit
    const form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (input && input.value.trim().length === 0) {
          e.preventDefault();
        }
      });
    }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });

    // Debounced search
    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        const query = input.value.trim();

        if (query.length < 2) {
          resultsContainer.innerHTML = '';
          return;
        }

        debounceTimer = setTimeout(() => {
          fetchResults(query);
        }, 300);
      });
    }

    function fetchResults(query) {
      if (!resultsContainer) return;
      resultsContainer.innerHTML = '<div class="ps-loading"><div class="spinner spinner--small"></div></div>';

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=6')
        .then(res => res.json())
        .then(data => {
          renderResults(data.resources.results, query);
        })
        .catch((err) => {
          console.error('Predictive Search Error:', err);
          resultsContainer.innerHTML = '<p class="ps-empty">Search is temporarily unavailable.</p>';
        });
    }

    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function renderResults(results, query) {
      if (!resultsContainer) return;
      let html = '';
      let hasResults = false;

      // Products
      if (results.products && results.products.length > 0) {
        hasResults = true;
        html += '<div class="ps-group">';
        html += '<h3 class="ps-group__title">Products</h3>';
        html += '<div class="ps-group__items">';
        results.products.forEach(product => {
          const img = product.image ? product.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
          html += '<a href="' + product.url + '" class="ps-item ps-item--product">';
          if (img) {
            html += '<img class="ps-item__image" src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="60" height="60">';
          }
          html += '<div class="ps-item__info">';
          html += '<span class="ps-item__title">' + escapeHtml(product.title) + '</span>';
          html += '<span class="ps-item__price">$' + product.price + '</span>';
          html += '</div>';
          html += '</a>';
        });
        html += '</div></div>';
      }

      // Articles (Lessons)
      if (results.articles && results.articles.length > 0) {
        hasResults = true;
        html += '<div class="ps-group">';
        html += '<h3 class="ps-group__title">Lessons & Articles</h3>';
        html += '<div class="ps-group__items">';
        results.articles.forEach(article => {
          html += '<a href="' + article.url + '" class="ps-item ps-item--article">';
          html += '<div class="ps-item__info">';
          html += '<span class="ps-item__title">' + escapeHtml(article.title) + '</span>';
          if (article.body) {
            html += '<span class="ps-item__excerpt">' + escapeHtml(article.body.substring(0, 80)) + '&hellip;</span>';
          }
          html += '</div>';
          html += '</a>';
        });
        html += '</div></div>';
      }

      // Pages
      if (results.pages && results.pages.length > 0) {
        hasResults = true;
        html += '<div class="ps-group">';
        html += '<h3 class="ps-group__title">Pages</h3>';
        html += '<div class="ps-group__items">';
        results.pages.forEach(page => {
          html += '<a href="' + page.url + '" class="ps-item ps-item--page">';
          html += '<div class="ps-item__info">';
          html += '<span class="ps-item__title">' + escapeHtml(page.title) + '</span>';
          html += '</div>';
          html += '</a>';
        });
        html += '</div></div>';
      }

      // View all link
      if (hasResults) {
        html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="ps-view-all">View all results for &ldquo;' + escapeHtml(query) + '&rdquo;</a>';
      }

      if (!hasResults) {
        html = '<p class="ps-empty">No results found for &ldquo;' + escapeHtml(query) + '&rdquo;</p>';
      }

      resultsContainer.innerHTML = html;
    }
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();
